import { createRoutine } from 'redux-saga-routines';

// fetch
export const fetchAllPlaybookInstances = createRoutine(
  'FETCH_ALL_PLAYBOOK_INSTANCES'
);
export const fetchPlaybookInstanceById = createRoutine(
  'FETCH_PLAYBOOK_INSTANCE_BY_ID'
);
export const resetSelectedPlaybookInstance = createRoutine(
  'RESET_SELECTED_PLAYBOOK_INSTANCE'
);
export const searchPlaybookInstances = createRoutine(
  'FETCH_ACTIVE_PLAYBOOK_INSTANCES'
);

export const fetchPlaybookInstanceChangelog = createRoutine(
  'FETCH_PLAYBOOK_INSTANCE_CHANGELOG'
);
export const completePlaybookInstance = createRoutine(
  'COMPLETE_PLAYBOOK_INSTANCE'
);

export const bulkCompletePlaybookInstance = createRoutine(
  'BULK_COMPLETE_PLAYBOOK_INSTANCE'
);

export const markInProgressPlaybookInstance = createRoutine(
  'MARK_IN_PROGRESS_PLAYBOOK_INSTANCE'
);

export const updatePlaybookInstance = createRoutine('UPDATE_PLAYBOOK_INSTANCE');
export const exportPlaybookInstances = createRoutine(
  'EXPORT_PLAYBOOK_INSTANCES'
);
export const archivePlaybookInstance = createRoutine(
  'ARCHIVE_PLAYBOOK_INSTANCE'
);

// other
export const showPlaybookInstanceAddEditForm = createRoutine(
  'SHOW_PLAYBOOK_INSTANCE_ADD_EDIT_FORM'
);

export const bulkArchivePlaybookInstances = createRoutine(
  'BULK_ARCHIVE_PLAYBOOK_INSTANCES'
);
export const bulkCompletePlaybookInstances = createRoutine(
  'BULK_COMPLETE_PLAYBOOK_INSTANCES'
);
